export function getQueryParamFromUrlSearch(search: string, param: string) {
  const urlParams = new URLSearchParams(search);
  return urlParams.get(param);
}

export function getQueryParamFromUrl(url: string, param: string) {
  const urlObject = new URL(url);
  return getQueryParamFromUrlSearch(urlObject.search, param);
}
